module.exports = __webpack_public_path__ + "e208fe6be5aba1643fd4b9ddbb959696.svg";